import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useState } from "react";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import { _localization } from "../../../config/location";
import { ActionIcon, Badge, Text, Title, Tooltip } from "@mantine/core";
import { EuiButtonIcon, EuiHealth, EuiLink } from "@elastic/eui";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { modifyDisableUserCommentReply } from "../../../api/ApiUserComment";
import { modals } from "@mantine/modals";
import DeleteView from "./DeleteView";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import EditReplyComments from "./EditReplyComments";
type Props = {
  dataDetail: any;
  onClose: any;
};
const ReplyComment = ({ dataDetail, onClose }: Props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);

  //table state

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  const handleEditReplyDisable = async (id: number) => {
    await modifyDisableUserCommentReply(id);
    onClose((prev: any) => !prev);
  };

  const EditItem = async (id: number) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa nội dung phản hồi khách hàng</Title>
        </>
      ),
      size: "auto",
      children: (
        <EditReplyComments
          id={id}
          onClose={(shouldRefresh?: any) => {
            if (shouldRefresh === true) {
              onClose(true);
            } else if (typeof shouldRefresh === "function") {
              // Handle state setter function
              setDeleteViewStatus(shouldRefresh);
            } else {
              // Default behavior
              onClose((prev: any) => !prev);
            }
          }}
          isEditMode={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };

  const deleteItem = (idItem: number[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa phản hồi</Title>
        </>
      ),
      children: (
        <DeleteView idItem={idItem} isEditMode={false} onClose={onClose} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "userName",
        header: "khách hàng",
      },
      {
        accessorKey: "userEmail",
        header: "Email khách hàng",
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        size: 485,
      },
      {
        accessorKey: "creationDate",
        header: "Ngày",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "approved",
        header: "Trạng thái",
        Cell: ({ row }) => {
          const { id, approved } = row.original;
          return (
            <EuiLink
              target="_blank"
              onClick={(e: any) => {
                handleEditReplyDisable(id);
              }}
            >
              <EuiHealth color={approved === 1 ? "green" : "danger"}>
                {approved === 1 ? "Đã duyệt" : "Chưa duyệt"}
              </EuiHealth>
            </EuiLink>
          );
        },
        size: 120,
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        Cell: ({ row }) => {
          const { id } = row.original;
          // const idEdit = row.original.commentId;
          return (
            <>
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="subtle"
                  onClick={() =>
                    !id
                      ? NotificationExtension.Warn(
                          "Xin vui lòng chọn dữ liệu !"
                        )
                      : EditItem(id)
                  }
                >
                  <EuiButtonIcon iconType="documentEdit" color="success" />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon variant="subtle" onClick={() => deleteItem([id])}>
                  <EuiButtonIcon iconType="trash" color="danger" />
                </ActionIcon>
              </Tooltip>
            </>
          );
        },
        size: 80,
        enableColumnActions: false,
        enableSorting: false,
      },
    ],
    []
  );
  const table = useMantineReactTable({
    columns,
    data: dataDetail,
    enableColumnResizing: false,
    columnResizeMode: "onChange",
    positionToolbarAlertBanner: "bottom",
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["maCt"],
        right: ["actions"],
      },
      columnVisibility: { id: false, "mrt-row-select": false },
      //   density: "xs",
    },
    // mantineTableContainerProps: {
    //   style: {
    //     maxHeight: isSetHeight ? height : 500,
    //     minHeight: isSetHeight ? height : 100,
    //   },
    // },
    enableStickyHeader: true,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableTopToolbar: false,
    rowCount,
    enablePagination: false,
    enableBottomToolbar: false,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      //   rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableContainerProps: {
      style: {
        width: "100%",
      },
    },
    mantineTableProps: {
      style: {
        width: "100%",
        tableLayout: "fixed",
      },
      striped: false,
    },
  });
  return (
    <>
      <div style={{ marginLeft: "100px", marginRight: "100px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ReplyComment;
